import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { AssetService } from './services/asset.service';
import { ArticleComponent } from './article/article.component';
import { ExerciseComponent } from './exercise/exercise.component';
import { AssetPickerComponent } from './asset-picker/asset-picker.component';
import { AssetListComponent } from './asset-list/asset-list.component';
import { ArticleListComponent } from './article-list/article-list.component';
import { ExerciseListComponent } from './exercise-list/exercise-list.component';
import { AdminViewAssetComponent } from './admin-view-asset/admin-view-asset.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule
    ,RouterModule
    ,SharedModule
  ],
  declarations: [ArticleComponent, AssetPickerComponent, ExerciseComponent, AssetListComponent, ArticleListComponent, ExerciseListComponent, AdminViewAssetComponent]
  ,providers: [AssetService]
  ,exports: [ArticleComponent, AssetPickerComponent, ExerciseComponent, ExerciseListComponent, AdminViewAssetComponent]
})
export class LibraryAssetsModule { }



// WEBPACK FOOTER //
// ./src/app/library-assets/library-assets.module.ts